import React from "react";
import "./App.css";

function App() {
  return (
    <div className="app">
      <div className="brand-container">
        <h1 className="brand-name">Sabrix <span>Global</span></h1>
        <p className="coming-soon">Coming Soon</p>
      </div>
    </div>
  );
}

export default App;
